import React from 'react';
import { FileText, LayoutTemplate, Sparkles, ShieldCheck } from 'lucide-react';
import AdminPages from './AdminPages';

const AdminPageContents = () => {
  return (
    <div className="w-full px-6 py-10 space-y-10">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Sayfa İçerikleri</h1>
          <p className="text-sm text-gray-500">
            İçerik bloklarını düzenlemek için bir sayfa seçin.
          </p>
        </div>
      </div>

      <section className="rounded-3xl border border-gray-200 bg-white shadow-xl">
        <div className="border-b border-gray-200 px-8 py-6">
          <h2 className="text-lg font-semibold text-gray-900">İçerik Düzenleyici</h2>
        </div>

        <div className="px-2 pb-6 pt-4 md:px-6">
          <AdminPages standalone={false} />
        </div>
      </section>
    </div>
  );
};

export default AdminPageContents;

